import { render, staticRenderFns } from "./PositionsRequirement.vue?vue&type=template&id=70d494e9"
import script from "./PositionsRequirement.vue?vue&type=script&lang=ts"
export * from "./PositionsRequirement.vue?vue&type=script&lang=ts"
import style0 from "./PositionsRequirement.vue?vue&type=style&index=0&id=70d494e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports